import React, { useCallback, useEffect, useState } from "react";
import { LuSun, LuMoon } from "react-icons/lu";
import { t } from "../../i18n";
import { THEME_KEY, applyTheme, getStoredTheme, resolveTheme, storeTheme } from "../../lib/theme";

// Sun/moon switch. The label names the mode it will activate; the icon shows that mode too.
const ThemeToggle = ({ className = "" }) => {
  const [theme, setTheme] = useState(() => resolveTheme());

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  // Follow the device while the user has not chosen, and stay in step with other tabs.
  useEffect(() => {
    const media = window.matchMedia ? window.matchMedia("(prefers-color-scheme: dark)") : null;
    const onSystem = () => {
      if (!getStoredTheme()) setTheme(media.matches ? "dark" : "light");
    };
    const onStorage = (event) => {
      if (event.key === THEME_KEY) setTheme(resolveTheme());
    };
    media?.addEventListener?.("change", onSystem);
    window.addEventListener("storage", onStorage);
    return () => {
      media?.removeEventListener?.("change", onSystem);
      window.removeEventListener("storage", onStorage);
    };
  }, []);

  const toggle = useCallback(() => {
    const next = theme === "dark" ? "light" : "dark";
    storeTheme(next);
    setTheme(next);
  }, [theme]);

  const toDark = theme !== "dark";
  const label = toDark ? t("التبديل إلى الوضع الداكن") : t("التبديل إلى الوضع الفاتح");
  const Icon = toDark ? LuMoon : LuSun;

  return (
    <button type="button" onClick={toggle} aria-label={label} title={label} className={className}>
      <Icon aria-hidden="true" />
    </button>
  );
};

export default ThemeToggle;
